<template>
  <div style="padding:14px 10px">
    <div class="cur_route">{{$route.name}}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="conts fcl">
      <div class="frw fac">
        <div class="nav_item frw fac " :class="{nav_item_s:i==nav_index}" v-for="(item,i) in navs" :key="i"
          @click="navChange(i)">{{item}}
        </div>
      </div>
      <div class="div_cont box-sizing">
        <systemUser v-if="nav_index==0" />
        <systemUserGroup v-if="nav_index==1" />
        <systemLog v-if="nav_index==2" />
        <settingList v-if="nav_index==3" />
      </div>
    </div>

  </div>
</template>
<script>
  import systemUser from './system_user.vue'
  import systemUserGroup from './system_user_group.vue'
  import systemLog from './system_log.vue'
  import settingList from './setting_list.vue'
  export default {
    components: {
      systemUser,
      systemUserGroup,
      systemLog,
      settingList
    },
    data() {
      return {
        navs: ['User', 'User Group', 'Logs', 'Config'],
        nav_index: 0
      }
    },
    methods: {
      navChange(i) {
        this.nav_index = i
      }
    }
  }

</script>
<style scoped>
  .conts {
    margin-top: 20px;
  }

  .nav_item {
    height: 50px;
    padding: 0 22px;
    background: rgba(0, 184, 194, .05);
    border-radius: 16px 16px 0 0;
    color: rgba(11, 50, 117, .7);
    font-size: 14px;
    margin-right: 1px;
    border: 1px solid #fff;
    cursor: pointer;
  }

  .nav_item_s {
    color: #00b8c2;
    background: #fff;
    box-shadow: 5px 0 10px rgba(3, 97, 240, .12);
  }

</style>



// WEBPACK FOOTER //
// src/views/system/setting.vue